import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import { Header,
    Form,
    Button,
    Segment,
    Icon,
    Dropdown,
    Divider,
    List } from 'semantic-ui-react';
import { api } from '../../../services/api';

import Navbarr from '../../../components/Navbar';

import './styles.css';

export default function RouteEdit ({ sidebar: Sidebar}) {
    const { id } = useParams();
    const [routeStates, setRouteStates] = useState({
        route: {},
        formRoute: {
            id: '',
            nome: '',
            lojas: [],
            usuarios: []
        },
        stores: [],
        storeOptions: [],
        currentStores: [],
        users: [],
        usersOptions: [],
        currentUsers: [],
        isLoadingData: true,
        isEditing: false
    });

    async function handleStorUsers() {
        await handleStores();
        await handleUsers();
    }

    async function handleStores() {
        const currentStores = [];
        const storesOptions = [];
        const stores = await fetchStores();
        stores.forEach(
            stor => {
                storesOptions.push({key: stor['id'],
                                    text: stor['nome'],
                                    value: stor['id']});
            }
        );

        routeStates['route']['lojas'].forEach(
            stor => {
                currentStores.push(stor['id']);
            }
        );

        handleStoreChange(null, {value: currentStores});

        setRouteStates(state => ({
            ...state,
            stores: stores,
            storesOptions: storesOptions,
        }));
    }

    async function handleUsers() {
        const currentUsers = [];
        const usersOptions = [];
        const users = await fetchUsers();
        users.forEach(
            user => {
                usersOptions.push({key: user['email'],
                                    text: user['nome'],
                                    value: user['email']});
            }
        );

        routeStates['route']['usuarios'].forEach(
            usr => {
                currentUsers.push(usr['email']);
            }
        );

        handleUserChange(null, {value: currentUsers});
        setRouteStates(state => ({
            ...state,
            users: users,
            usersOptions: usersOptions,
        }));
    }

    async function fetchStores() {
        try {
            const data = await api.getStores();
            return data;
        } catch (err) {
            console.error("Falha ao obter lojas: ", err);
        }
    }

    async function fetchUsers() {
        try {
            const data = await api.getUsers();
            const dataUsers = data.filter( element => element['role'] === 'ROLE_USUARIO');
            return dataUsers;
        } catch (err) {
            console.error("Falha ao obter usuarios: ", err);
        }
    }

    const handleNomeChange = (e, {value}) => {
        setRouteStates( state => ({
            ...state,
            formRoute: {
                ...state['formRoute'],
                nome: value
            }
        }));
    }

    const handleStoreChange = (e, {value}) => {
        setRouteStates((prevState) => ({
            ...prevState,
            currentStores: value
        }));
    }

    const handleUserChange = (e, {value}) => {
        setRouteStates((prevState) => ({
            ...prevState,
            currentUsers: value
        }));
    }

    async function editRoute () {
        setRouteStates(prevState => ({
            ...prevState,
            isLoadingData: true
        }));

        await handleStorUsers();

        setRouteStates(state => ({
            ...state,
            isEditing: true,
            isLoadingData: false,
        }));
    }

    const cancelRouteEdit = () => {
        setRouteStates( state => ({
            ...state,
            formRoute: state['route'],
            isEditing: false
            }
        ));
    }

    async function handlePut() {
        try {

            setRouteStates( state => ({
                ...state,
                isLoading: true,
            }));

            const usuarios = [];
            const lojas = [];

            routeStates['currentUsers'].forEach(
                usr => usuarios.push({'email':usr})
            );

            routeStates['currentStores'].forEach(
                loja => lojas.push({'id':loja})
            );

            const data = await api.putRoute(routeStates['formRoute']['id'],
                                            routeStates['formRoute']['nome'],
                                            usuarios, lojas);
            setRouteStates( state => ({
                ...state,
                route: data,
                formRoute: {
                    ...state['formRoute'],
                    ...data
                },
                isLoadingData: false,
                isEditing: false
            }));
            Alert.success('Rota atualizada com sucesso!');
        } catch (err) {
            Alert.error('Falha ao atualizar rota.');
            console.error('Falha ao atualizar rota: ', err);
            setRouteStates( state => ({
                ...state,
                isLoadingData: false,
                isEditing: true
            }));
        }
    }

    useEffect(() => {
        async function fetchRoute() {
            try {
                const data = await api.getRouteById(id);
                setRouteStates( state => ({
                    ...state,
                    route: data,
                    formRoute: {
                        ...state['formRoute'],
                        ...data
                    },
                    isLoadingData: false
                }));
            } catch (err) {
                console.error("Falha ao obter rota: ", err);
            }
        }

        fetchRoute();
    },[id]);

    return (
        <Container className="r-content">
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"routelist"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{backgroundColor: '#FAFAFA', padding: '5px'}}>
                    <div>
                        <Segment
                            loading={routeStates['isLoadingData']}
                            style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                            >
                            <Header as='h3' floated='left'>
                                Informações da Rota
                            </Header>
                            {!routeStates['isEditing'] && <Button
                                primary
                                size="mini"
                                floated='right'
                                onClick={editRoute}
                                >
                                    <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                        <Icon name='edit'/> Editar
                                    </div>
                            </Button>}

                            <Divider clearing />
                            <Form>
                                <Form.Group inline>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='key'
                                            fluid label='Identificador'
                                            placeholder='Identificador'
                                            value={routeStates['formRoute'] ? routeStates['formRoute']['id']: ""}
                                            />

                                        <Form.Input
                                            readOnly={!routeStates['isEditing']}
                                            iconPosition='left'
                                            icon='map signs'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={routeStates['formRoute'] ? routeStates['formRoute']['nome']: ""}
                                            onChange={handleNomeChange}
                                        />
                                    </Form.Group>


                                    {routeStates['formRoute'] && routeStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Promotores</label>
                                        </Form.Group>
                                    }
                                    {routeStates['formRoute'] && routeStates['isEditing'] &&
                                        <Form.Group inline>
                                            <Dropdown
                                                disabled={!routeStates['isEditing']}
                                                options={routeStates['usersOptions']}
                                                placeholder='Escolha Usuários'
                                                search
                                                selection
                                                fluid
                                                multiple
                                                value={routeStates['currentUsers']}
                                                onChange={handleUserChange}
                                            />
                                        </Form.Group>
                                    }

                                    {/* Dropdown lojas*/}
                                    {routeStates['formRoute'] && routeStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Lojas</label>
                                        </Form.Group>
                                    }

                                    {routeStates['formRoute'] && routeStates['isEditing'] &&
                                        <Form.Group inline>
                                            <Dropdown
                                                disabled={!routeStates['isEditing']}
                                                options={routeStates['storesOptions']}
                                                placeholder='Escolha lojas'
                                                search
                                                selection
                                                fluid
                                                multiple
                                                value={routeStates['currentStores']}
                                                onChange={handleStoreChange}
                                            />
                                        </Form.Group>
                                    }

                                    {routeStates['formRoute'] && !routeStates['isEditing']
                                        &&
                                        <Header as='h4' dividing>
                                            <Header.Content>
                                                Promotores
                                            </Header.Content>
                                        </Header>
                                    }
                                    {routeStates['formRoute'] && !routeStates['isEditing'] && <List divided relaxed style={{marginTop: '30px'}}>
                                        {routeStates['formRoute']['usuarios'].map((usr) => {
                                            return (
                                                <List.Item key={usr['email']}>
                                                    <List.Content>
                                                        <List.Header style={{fontSize: '13px'}}>
                                                            {usr['nome']}
                                                        </List.Header>
                                                        <List.Description style={{fontSize: '12px'}}>Email: {usr['email']}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                                )
                                            })
                                        }
                                    </List> }

                                    {routeStates['formRoute'] && !routeStates['isEditing']
                                        &&
                                        <Header as='h4' dividing>
                                            <Header.Content>
                                                Lojas
                                            </Header.Content>
                                        </Header>
                                    }
                                    {routeStates['formRoute'] && !routeStates['isEditing'] && <List divided relaxed style={{marginTop: '30px'}}>
                                        {routeStates['formRoute']['lojas'].map((loja) => {
                                            return (
                                                <List.Item key={loja['id']}>
                                                    <List.Content>
                                                        <List.Header style={{fontSize: '13px'}}>
                                                            {loja['nome']}
                                                        </List.Header>
                                                        <List.Description style={{fontSize: '12px'}}>Identificador: {loja['id']}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                                )
                                            }
                                        )
                                    }
                                    </List> }

                                    <Form.Group>
                                        {routeStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            type='submit'
                                            size="mini"
                                            floated='right'
                                            onClick={handlePut}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>}
                                        {routeStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            color='red'
                                            size="mini"
                                            floated='right'
                                            onClick={cancelRouteEdit}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='cancel'/> Cancelar
                                                </div>
                                        </Button>}
                                    </Form.Group>
                                </Form>
                        </Segment>
                    </div>
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
